import { type ObjectiveMedia } from '@teachur/http-client';

/**
 * Determines if a media item is a video based on URL patterns
 * YouTube, Vimeo, and other video hosting platforms
 */
const isVideoUrl = (url: string): boolean => {
  const videoPatterns = [
    /youtube\.com/i,
    /youtu\.be/i,
    /vimeo\.com/i,
    /dailymotion\.com/i,
    /wistia\.com/i,
    /\.mp4$/i,
    /\.webm$/i,
    /\.ogg$/i,
  ];

  return videoPatterns.some((pattern) => pattern.test(url));
};

/**
 * Determines if a media item is a video or article
 * If file is null/undefined and URL is a video URL, it's a video
 * Otherwise, it's an article
 */
export const getMediaType = (media: ObjectiveMedia): 'video' | 'article' => {
  if (!media.file && media.url && isVideoUrl(media.url)) {
    return 'video';
  }
  return 'article';
};

/**
 * Filter media array by type
 */
export const filterMediaByType = (
  media: ObjectiveMedia[],
  type: 'video' | 'article' | 'all'
): ObjectiveMedia[] => {
  if (type === 'all') return media;
  return media.filter((item) => getMediaType(item) === type);
};

/**
 * Validate URL to prevent malicious URLs
 */
export const isValidUrl = (url: string | undefined) => {
  if (!url) return false;
  try {
    new URL(url);
    return url.startsWith('http://') || url.startsWith('https://');
  } catch {
    return false;
  }
};
